export default __webpack_public_path__ + "static/media/nft-buy-and-sell-icon.47c75d84.svg";